export interface SevenTVEmote {
  id: string;
  name: string;
  url1x: string;
  url2x: string;
}

export type EmoteToken =
  | { kind: 'text'; text: string }
  | { kind: 'emote'; emote: SevenTVEmote };

/**
 * Split a text string into text/emote tokens by matching whole words
 * against the provided 7TV emote map. Adjacent text tokens are merged.
 */
export function tokenize(text: string, emotes: Map<string, SevenTVEmote>): EmoteToken[] {
  if (!emotes.size) return [{ kind: 'text', text }];

  const words = text.split(' ');
  const result: EmoteToken[] = [];

  for (let i = 0; i < words.length; i++) {
    const word = words[i] ?? '';
    const space = i > 0 ? ' ' : '';
    const emote = emotes.get(word);

    if (emote) {
      if (space) {
        const last = result[result.length - 1];
        if (last?.kind === 'text') last.text += space;
        else result.push({ kind: 'text', text: space });
      }
      result.push({ kind: 'emote', emote });
    } else {
      const last = result[result.length - 1];
      if (last?.kind === 'text') {
        last.text += space + word;
      } else {
        result.push({ kind: 'text', text: space + word });
      }
    }
  }

  return result;
}
